export default __webpack_public_path__ + "static/media/placement-introduction.f1801476.gif";